/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const escoSkillDataSchema = z.object({
	conceptUri: z.string(),
	preferredLabel: z.string(),
	confirmedByUser: z.boolean(),
})

export type EscoSkillDataSchema = z.infer<typeof escoSkillDataSchema>
